/**
 * Helpers for rendering values that may not be set yet.
 *
 * A work order saved as a draft can be missing almost anything — no location, no
 * client, no manager. Interpolating those into a template literal is what turns
 * an empty cell into the literal text "undefined, undefined": React renders
 * null/undefined as nothing, but `${undefined}` is the five-character string.
 */

const isBlank = (value) =>
  value === null || value === undefined || String(value).trim() === "";

/**
 * Joins the parts that actually have a value, dropping the separator for the
 * ones that don't. Returns "" when nothing is set, so the cell renders empty
 * rather than showing stray punctuation like ", ".
 */
export const joinNonEmpty = (parts = [], separator = ", ") =>
  parts.filter((part) => !isBlank(part)).join(separator);

/** "First Last", "First", or "" — never "undefined undefined". */
export const fullName = (person) => joinNonEmpty([person?.firstName, person?.lastName], " ");

/** Any single value, with "" instead of null/undefined. */
export const orEmpty = (value) => (isBlank(value) ? "" : value);

const displayValue = { joinNonEmpty, fullName, orEmpty };

export default displayValue;
